import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M188,1544.88673 L561.6325,1918.48769 L622.4025,1857.80864 L352.285,1587.71395 L1725.0175,1587.71395 L1725.0175,1501.97369 L352.285,1501.97369 L622.4025,1231.87899 L561.6325,1171.28577 L188,1544.88673 Z M755.598667,85.826087 L918.338667,85.826087 L918.338667,629.019391 L755.598667,629.019391 C605.8195,629.019391 483.936167,507.232174 483.936167,357.465652 C483.936167,207.613304 605.8195,85.826087 755.598667,85.826087 M755.598667,714.845478 L918.338667,714.845478 L918.338667,1255.20652 L1004.172,1255.20652 L1004.172,85.826087 L1229.82783,85.826087 L1229.82783,1255.20652 L1315.66117,1255.20652 L1315.66117,85.826087 L1481.40533,85.826087 L1481.40533,0 L755.598667,0 C558.525333,0 398.102833,160.32313 398.102833,357.465652 C398.102833,554.522348 558.525333,714.845478 755.598667,714.845478",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextDirectionRtlLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTextDirectionRtlLine, _Component);

  var _super = _createSuper(IconTextDirectionRtlLine);

  function IconTextDirectionRtlLine() {
    _classCallCheck(this, IconTextDirectionRtlLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextDirectionRtlLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextDirectionRtl",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextDirectionRtlLine.displayName = "IconTextDirectionRtlLine";
  return IconTextDirectionRtlLine;
}(Component);

IconTextDirectionRtlLine.glyphName = 'text-direction-rtl';
IconTextDirectionRtlLine.variant = 'Line';
IconTextDirectionRtlLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextDirectionRtlLine;
export { IconTextDirectionRtlLine };